import { CookiesProvider, useCookies } from 'react-cookie';
import { Route, Routes } from 'react-router';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ScrollToTop from './common/ScrollToTop';
import { AccessDeniedPage } from './pages/AccessDeniedPage/AccessDeniedPage';
import LoginPage from './pages/LoginPage/LoginPage';
import LoginResetPage from './pages/LoginResetPage/LoginResetPage';
import ResetPassPage from './pages/LoginResetPage/ResetPassPage/ResetPassPage';
import { NotFoundPage } from './pages/NotFoundPage/NotFoundPage';
import Registration from './pages/Registration/Registration';
import SuccessActivated from './pages/Registration/SuccessActivated/SuccessActivated';
import SuccessRegistred from './pages/Registration/SuccessRegistred/SuccessRegistred';
import GetNewToken from './pages/getNewToken/GetNewToken';
import TicketSuccess from './pages/getNewToken/TicketSuccess';
import { Main } from './pages/main/Main';
import { Main2 } from './pages/main2/Main2';
import { Main3 } from './pages/main3/Main3';
import PublicPages from './routes/public/PublicPages';
import ManagerCabinet from './pages/cabinets/ManagerCabinet/ManagerCabinet';
import AdminQueueCabinet from './pages/cabinets/AdminCabinet/AdminQueueCabinet';
import QRCodeStand from './pages/QRCodeStand/QRCodeStand';

const App = () => {
	const [cookies, setCookie] = useCookies(['user']);

	return (
		<>
			<CookiesProvider>
				<ToastContainer />
				<Router basename='/'>
					<ScrollToTop />
					<Routes>
						<Route
							path='/'
							element={
								<PublicPages>
									<Main3 />
								</PublicPages>
							}
						/>
						<Route
							path='/home2'
							element={
								<PublicPages>
									<Main2 />
								</PublicPages>
							}
						/>
						<Route
							path='/home3'
							element={
								<PublicPages>
									<Main />
								</PublicPages>
							}
						/>
						<Route
							path='/new-token'
							element={
								<PublicPages>
									<GetNewToken />
								</PublicPages>
							}
						/>
						<Route
							path='/my-token'
							element={
								<PublicPages>
									<TicketSuccess />
								</PublicPages>
							}
						/>
						<Route
							path='/login'
							element={
								<PublicPages>
									<LoginPage />
								</PublicPages>
							}
						/>
						<Route
							path='/manager'
							element={
								<PublicPages>
									<ManagerCabinet />
								</PublicPages>
							}
						/>

						<Route
							path='/admin'
							element={
								<PublicPages>
									<AdminQueueCabinet />
								</PublicPages>
							}
						/>

						<Route
							path='/kiosk'
							element={
								<PublicPages>
									<QRCodeStand />
								</PublicPages>
							}
						/>

						<Route
							path='/registration'
							element={
								<PublicPages>
									<Registration />
								</PublicPages>
							}
						/>
						<Route
							path='*'
							element={
								<PublicPages>
									<NotFoundPage />
								</PublicPages>
							}
						/>
						<Route
							path='/access-denied'
							element={
								<PublicPages>
									<AccessDeniedPage />
								</PublicPages>
							}
						/>

						<Route
							path='/reset-password'
							element={
								<PublicPages>
									<LoginResetPage />
								</PublicPages>
							}
						/>
						<Route
							path='/reset-pass'
							element={
								<PublicPages>
									<ResetPassPage />
								</PublicPages>
							}
						/>
						<Route
							path='/success-activated'
							element={
								<PublicPages>
									<SuccessActivated />
								</PublicPages>
							}
						/>
						<Route
							path='/success-registered'
							element={
								<PublicPages>
									<SuccessRegistred />
								</PublicPages>
							}
						/>
					</Routes>
				</Router>
			</CookiesProvider>
		</>
	);
};

export default App;
